var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.$mq === 'sm' || _vm.$mq === 'md' ? 'text-center mt-4' : 'text-center m-top-7']},[_c('img',{attrs:{"src":require("../assets/no-result.svg"),"alt":""}}),_c('p',{class:[
            _vm.$mq === 'sm' || _vm.$mq === 'md'
                ? 'mt-4 fsz-12 m-bottom-4 primary-color fw-bold'
                : 'm-top-7 m-bottom-4 fsz-14 primary-color fw-bold' ]},[_vm._v(" There is no notification ")])])}
var staticRenderFns = []

export { render, staticRenderFns }